module.exports = __webpack_public_path__ + "img/baylissj.626a978b.jpg";